const Approvals = () => import(/* webpackChunkName: "approvals" */ '@/views/approvals/Index');
const RequestDashboard = () => import(
  /* webpackChunkName: "approvals" */ '@/views/approvals/RequestDashboard'
);
const RequestWizard = () => import(
  /* webpackChunkName: "approvals" */ '@/views/approvals/requestwizard/Index'
);
const RequestDetail = () => import(
  /* webpackChunkName: "approvals" */
  '@/views/approvals/Detail'
);
const RequestList = () => import(
  /* webpackChunkName: "approvals" */
  '@/views/approvals/RequestList'
);
const FlowList = () => import(
  /* webpackChunkName: "approvals" */ '@/views/approvals/flows/List'
);
const NewFlow = () => import(
  /* webpackChunkName: "approvals" */ '@/views/approvals/flows/New'
);
const FlowDetail = () => import(
  /* webpackChunkName: "approvals" */ '@/views/approvals/flows/Detail'
);

export default {
  path: '/approvals',
  component: Approvals,
  children: [
    {
      path: '',
      component: RequestDashboard
    },
    {
      path: 'flows',
      component: FlowList
    },
    {
      path: 'flows/new',
      component: NewFlow
    },
    {
      path: 'flows/:id',
      component: FlowDetail,
      props: true
    },
    {
      path: 'request',
      component: RequestWizard
    },
    {
      path: 'requests/:userId/:created',
      component: RequestDetail,
      props: true
    },
    {
      name: 'ApprovalRequestList',
      path: 'list',
      component: RequestList,
      props: true
    }
  ]
};
